import { queryOptions } from "@tanstack/react-query";
import { listAiaAwards, listAiaAwardsAdmin } from "./aia-awards.functions";

export type AiaAward = {
  id: string;
  category: "industry" | "leadership";
  name: string;
  description: string | null;
  image_path: string | null;
  article_url: string | null;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export const aiaAwardsQueryOptions = () =>
  queryOptions({
    queryKey: ["aia_awards"],
    queryFn: async () => (await listAiaAwards()) as AiaAward[],
  });

export const aiaAwardsAdminQueryOptions = () =>
  queryOptions({
    queryKey: ["aia_awards", "admin"],
    queryFn: async () => (await listAiaAwardsAdmin()) as AiaAward[],
  });
